"use client";

import { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";

import PropTypes from "prop-types";

import SaveTheSearchButton from "components/save-the-search-button";
import TriggerAlert from "@/src/components/listing-search/trigger-alert";

import { numberFormatter } from "helpers/number-formatter";

import { toggleSaveSearchTrigger } from "@/src/store/listingSearch";

import styles from "./styles.module.css";

const TopItemsWrapper = ({ name, urlPath, totalListingLength, listingName, seoTitle }) => {
  const dispatch = useDispatch();

  const showPopup = useSelector((state) => state.listingSearch.saveSearchTrigger);

  const [stickyActive, setStickyActive] = useState(false);

  const handleClosePopup = () => {
    dispatch(toggleSaveSearchTrigger(false));
  };

  useEffect(() => {
    checkScrollVisibility();
    const handleScroll = () => checkScrollVisibility();

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const checkScrollVisibility = (threshold = 205) => {
    const scrollY = window.scrollY;
    if (scrollY > threshold) {
      setStickyActive(true);
    } else {
      setStickyActive(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.titleContainer}>
        <div className={styles.mainTitle}>
          <h1 className={styles.title}>{seoTitle?.h1}</h1>
          {totalListingLength > 0 ? (
            <span className={styles.adsCount}>
              araması için <strong className={styles.strong}>{numberFormatter(totalListingLength)}</strong> ilan bulundu
            </span>
          ) : (
            <span className={styles.adsCount}>araması için uygun ilan bulunamadı</span>
          )}
        </div>
        <h2 className={styles.subTitle}>{seoTitle?.h2}</h2>
      </div>
      <div className={styles.boardingWrapper}>
        <SaveTheSearchButton name={name} urlPath={urlPath} FlashingDot={showPopup && !stickyActive} />
        {showPopup && !stickyActive && <TriggerAlert onClose={handleClosePopup} />}
      </div>
    </div>
  );
};

TopItemsWrapper.propTypes = {
  name: PropTypes.string,
  urlPath: PropTypes.string,
  totalListingLength: PropTypes.number,
  listingName: PropTypes.string,
  seoTitle: PropTypes.object,
};

export default TopItemsWrapper;
